import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';
import { 
  Phone, 
  Clock, 
  Award, 
  Wrench, 
  CheckCircle,
  Shield,
  DollarSign,
  Star,
  ArrowRight,
  Calendar,
  ExternalLink,
  Play,
  Thermometer,
  Flame,
  Battery,
  Home,
  AlertTriangle,
  TrendingUp,
  Zap,
  Timer,
  Sun,
  Target,
  Gift,
  XCircle
} from 'lucide-react';
import { SchemaInjector } from '../components/SchemaInjector';

const FlatRateRheemHeaterPricing = () => {
  // Unified Schema for the entire page
  const completePageSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#webpage",
        "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado",
        "name": "$2000 Water Heater Deal Denver: Rheem & AO Smith | Colorado First Plumbing",
        "description": "Get a 40-gallon Rheem or AO Smith water heater fully installed for a flat-rate of $2,000 in the Denver Metro area. 50-gallon for $2,100. 360 Google Reviews. No hidden fees.",
        "isPartOf": { "@id": "https://colorado-plumbing.com/#website" },
        "breadcrumb": { "@id": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#breadcrumb" }
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#breadcrumb",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://colorado-plumbing.com/" },
          { "@type": "ListItem", "position": 2, "name": "$2000 Water Heater Deal", "item": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado" }
        ]
      },
      {
        "@type": "Plumber",
        "@id": "https://colorado-plumbing.com/",
        "name": "Colorado First Plumbing and Sewer LLC",
        "image": "https://colorado-plumbing.com/colorado-plumbing-uploads/brand/Colorado-First-Plumbing-Logo-Transparent.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "5108 Sydney Ave", "addressLocality": "Littleton", "addressRegion": "CO", "postalCode": "80130", "addressCountry": "US"
        },
        "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado",
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "areaServed": [
          { "@type": "City", "name": "Denver" },
          { "@type": "City", "name": "Littleton" },
          { "@type": "City", "name": "Highlands Ranch" }
        ]
      },
      {
        "@type": "Product",
        "name": "40 Gallon Rheem Water Heater - Fully Installed",
        "image": ["/colorado-plumbing-uploads/rheem-aosmith-water-heaters/rheem-50-gallon-replacement-thermal-tank-centennial.JPEG"],
        "description": "Flat-rate $2,000 installation of a 40-gallon Rheem natural gas, atmospheric vented water heater in Denver metro. Includes all labor by licensed master plumber, thermal expansion tank, drain pan, installation materials, disposal of old unit",
        "sku": "DEAL-RHEEM-40-ATM",
        "brand": { "@type": "Brand", "name": "Rheem" },
        "offers": { "@type": "Offer", "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#40-gallon-deal", "priceCurrency": "USD", "price": "2000", "availability": "https://schema.org/InStock", "priceValidUntil": "2025-12-31" },
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How much does a 40-gallon Rheem water heater cost in Denver?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "$2,000 flat-rate, fully installed. This covers all labor, materials, standard installation, and disposal—no hidden fees."
            }
          },
          {
            "@type": "Question",
            "name": "What is included in the water heater installation?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The $2,000 price includes the new Rheem 40-gallon gas water heater, installation by a licensed master plumber, thermal expansion tank, drain pan, two flex water lines, gas drip leg, code updates, and removal/disposal of your old unit."
            }
          },
          {
            "@type": "Question",
            "name": "Is the thermal expansion tank included?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, the thermal expansion tank is included at no extra charge as part of our all-inclusive, code-compliant installation."
            }
          },
          {
            "@type": "Question",
            "name": ",000 installation?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": ""
            }
          }
        ]
      },
      {
        "@type": "Product",
        "name": "50 Gallon Rheem Water Heater - Fully Installed",
        "image": ["/colorado-plumbing-uploads/rheem-aosmith-water-heaters/50-gallon-replacement-thornton.JPEG"],
        "description": "Flat-rate $2,100 installation of a 50-gallon Rheem natural gas, atmospheric vented water heater in Denver metro. All labor by licensed master plumber, thermal expansion tank, drain pan, installation materials, disposal of old unit",
        "sku": "DEAL-RHEEM-50-ATM",
        "brand": { "@type": "Brand", "name": "Rheem" },
        "offers": { "@type": "Offer", "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#50-gallon-deal", "priceCurrency": "USD", "price": "2100", "availability": "https://schema.org/InStock", "priceValidUntil": "2025-12-31" },
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How much does a 50-gallon Rheem water heater cost in Denver?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "$2,100 flat-rate, fully installed. This covers all labor, materials, standard installation, and old unit disposal—no surprise fees."
            }
          },
          {
            "@type": "Question",
            "name": "What is included in the 50-gallon water heater installation?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Your $2,100 price includes the new 50-gallon Rheem gas water heater, installation by a licensed master plumber, thermal expansion tank, drain pan, two flex water lines, gas drip leg, code upgrades, and removal/disposal of the old water heater."
            }
          },
          {
            "@type": "Question",
            "name": "Who is a 50-gallon water heater best for?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "50-gallon tanks are perfect for homes with 3–5 people or higher hot water use, such as multiple bathrooms or large tubs."
            }
          },
          {
            "@type": "Question",
            "name": "Will a 50-gallon unit use more energy than a 40-gallon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "A 50-gallon tank uses about $3–$5 more per month, providing greater hot water capacity. Energy efficiency ratings are very similar between the two sizes."
            }
          }
        ]
      },
      {
        "@type": "Product",
        "name": "40 Gallon AO Smith Water Heater - Fully Installed",
        "image": ["/colorado-plumbing-uploads/locations/denver/ao-smith-skinny-40-gallon-installed-denver.JPEG"],
        "description": "Flat-rate $2,000 installation of a 40-gallon AO Smith natural gas, atmospheric vented water heater in Denver metro. Includes all labor by licensed master plumber, thermal expansion tank, drain pan, installation materials, disposal of old unit",
        "sku": "DEAL-AOS-40-ATM",
        "brand": { "@type": "Brand", "name": "AO Smith" },
        "offers": { "@type": "Offer", "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#40-gallon-deal", "priceCurrency": "USD", "price": "2000", "availability": "https://schema.org/InStock", "priceValidUntil": "2025-12-31" },
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How much does a 40-gallon AO Smith water heater cost in Denver?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "$2,000 flat-rate, fully installed. This covers all labor, materials, standard installation, and disposal—no hidden fees."
            }
          },
          {
            "@type": "Question",
            "name": "What is included in the water heater installation?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The $2,000 price includes the new AO Smith 40-gallon gas water heater, installation by a licensed master plumber, thermal expansion tank, drain pan, two flex water lines, gas drip leg, code updates, and removal/disposal of your old unit."
            }
          },
          {
            "@type": "Question",
            "name": "Are there any disposal fees for my old water heater?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "No—removal and recycling of your old water heater is included in the flat-rate price."
            }
          },
          {
            "@type": "Question",
            "name": "What are the requirements and limitations for this deal?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "This offer is for accessible natural gas-to-natural gas replacements, standard 40-gallon tank size, and standard piping only. Additional charges may apply for galvanized pipes, crawlspace/attic access, or special-order sizes."
            }
          }
        ]
      },
      {
        "@type": "Product",
        "name": "50 Gallon AO Smith Water Heater - Fully Installed",
        "image": ["/colorado-plumbing-uploads/rheem-aosmith-water-heaters/AOSmith-Water-Heater-Special.JPEG"],
        "description": "Flat-rate $2,100 installation of a 50-gallon AO Smith natural gas, atmospheric vented water heater in Denver metro. All labor by licensed master plumber, thermal expansion tank, drain pan, installation materials, disposal of old unit",
        "sku": "DEAL-AOS-50-ATM",
        "brand": { "@type": "Brand", "name": "AO Smith" },
        "offers": { "@type": "Offer", "url": "https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado#50-gallon-deal", "priceCurrency": "USD", "price": "2100", "availability": "https://schema.org/InStock", "priceValidUntil": "2025-12-31" },
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "360" },
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How much does a 50-gallon AO Smith water heater cost in Denver?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "$2,100 flat-rate, fully installed. This covers all labor, materials, standard installation, and old unit disposal—no surprise fees."
            }
          },
          {
            "@type": "Question",
            "name": "What is included in the 50-gallon water heater installation?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Your $2,100 price includes the new 50-gallon AO Smith gas water heater, installation by a licensed master plumber, thermal expansion tank, drain pan, two flex water lines, gas drip leg, code upgrades, and removal/disposal of the old water heater."
            }
          },
          {
            "@type": "Question",
            "name": "Is the thermal expansion tank included?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, every 50-gallon water heater installation comes with a thermal expansion tank at no extra cost (required for code compliance in Colorado)."
            }
          },
          {
            "@type": "Question",
            "name": "Do you charge extra to remove my old water heater?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "No. Hauling away and recycling your old tank is included in our flat-rate price."
            }
          },
          {
            "@type": "Question",
            "name": "What requirements and limitations apply?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Offer valid for accessible natural gas-to-natural gas replacements, standard 50-gallon tanks, and standard pipe connections only. Additional charges for galvanized pipe connections, special tank sizes, or hard-to-access locations."
            }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How much does a 40-gallon Rheem/AO Smith water heater cost in Denver?",
            "acceptedAnswer": { "@type": "Answer", "text": "$2,000 flat-rate, fully installed. This covers all labor, materials, standard installation, and disposal—no hidden fees." }
          },
          {
            "@type": "Question",
            "name": "What's included in the $2,000 40-gallon installation?",
            "acceptedAnswer": { "@type": "Answer", "text": "Our $2,000 deal includes: a Rheem or AO Smith 40-gallon atmospheric vented water heater, professional installation by a licensed master plumber, a thermal expansion tank, a water heater drain pan, 2 flex water lines, a gas drip leg assembly, bringing the system up to current IPC codes, and all necessary permits." }
          },
          {
            "@type": "Question",
            "name": "Is the thermal expansion tank included in the $2,000 price?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes, thermal expansion tanks are required by the International Plumbing Code (IPC) in most Colorado jurisdictions. We include the thermal expansion tank as part of our $2,000 and $2,100 flat-rate pricing, unlike other companies that add it as a surprise charge." }
          },
          {
            "@type": "Question",
            "name": "Do you charge extra to haul away the old water heater?",
            "acceptedAnswer": { "@type": "Answer", "text": "No, there are no extra disposal fees. We include the removal and proper recycling of your old water heater as part of our all-inclusive, flat-rate pricing. The price you see online is the price you pay." }
          },
          {
            "@type": "Question",
            "name": ",000 installation?",
            "acceptedAnswer": { "@type": "Answer", "text": "Additionally" }
          },
          {
            "@type": "Question",
            "name": "What are the requirements and limitations for this deal?",
            "acceptedAnswer": { "@type": "Answer", "text": "This offer is for accessible natural gas-to-natural gas replacements, standard 40-gallon tank size, and standard piping only. Additional charges may apply for galvanized pipes, crawlspace/attic access, or special-order sizes." }
          },
          {
            "@type": "Question",
            "name": "How much does a 50-gallon Rheem/AO Smith water heater cost in Denver?",
            "acceptedAnswer": { "@type": "Answer", "text": "$2,100 flat-rate, fully installed. This covers all labor, materials, standard installation, and old unit disposal—no surprise fees." }
          },
          {
            "@type": "Question",
            "name": "What's included in the $2,100 50-gallon installation?",
            "acceptedAnswer": { "@type": "Answer", "text": "Your $2,100 price includes the new 50-gallon Rheem or AO Smith gas water heater, installation by a licensed master plumber, thermal expansion tank, drain pan, two flex water lines, gas drip leg, code upgrades, and removal/disposal of the old water heater." }
          },
          {
            "@type": "Question",
            "name": "Is a 50-gallon unit right for my household?",
            "acceptedAnswer": { "@type": "Answer", "text": "A 50-gallon water heater is perfect for 3-5 person households or homes with high hot water usage (multiple bathrooms, large soaking tubs, etc.). It provides approximately 40-50 gallons of usable hot water per cycle, ensuring everyone gets hot showers even during peak usage times." }
          },
          {
            "@type": "Question",
            "name": "How much more energy does a 50-gallon use vs 40-gallon?",
            "acceptedAnswer": { "@type": "Answer", "text": "The energy difference is minimal - only about $3-5 more per month. Both sizes have similar energy efficiency ratings. The 50-gallon provides significantly more hot water capacity for just slightly higher operating costs, making it excellent value for larger households." }
          },
          {
            "@type": "Question",
            "name": "What's the recovery rate difference between 40 and 50 gallon?",
            "acceptedAnswer": { "@type": "Answer", "text": "Both 40 and 50-gallon atmospheric water heaters have similar recovery rates (about 40 gallons per hour). The main difference is storage capacity. The 50-gallon provides 10 extra gallons of ready hot water, reducing wait times between uses during peak demand periods." }
          },
          {
            "@type": "Question",
            "name": "What if I need a 50-gallon water heater?",
            "acceptedAnswer": { "@type": "Answer", "text": "A 50-gallon Rheem or AO Smith atmospheric gas water heater is $2,100 installed with the same flat-rate" }
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-950">
      <Header />
      <main>
        {/* AFFORDABLE WATER HEATER DEAL HERO */}
        <section className="relative pt-60 pb-20 bg-gradient-to-br from-blue-800 via-blue-700 to-blue-600 overflow-hidden">
          <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#FFFFFF_1px,transparent_1px)] [background-size:32px_32px]"></div>
          
          {/* Floating Summer Icons */}
          <div className="absolute top-20 left-10 animate-bounce">
            <Sun size={60} className="text-yellow-300 opacity-30" />
          </div>
          <div className="absolute top-32 right-20 animate-pulse">
            <Gift size={50} className="text-yellow-200 opacity-40" />
          </div>
          <div className="absolute bottom-20 left-20 animate-bounce delay-1000">
            <Target size={40} className="text-white opacity-30" />
          </div>
          
          <div className="container-custom text-center relative z-10">
            {/* AFFORDABLE DEAL BANNER */}
            <div className="inline-flex items-center px-6 py-3 mb-8 rounded-full bg-gradient-to-r from-yellow-400 to-orange-400 text-black font-black text-lg shadow-2xl animate-pulse border-4 border-white">
              <DollarSign size={24} className="mr-3" />
              🏆 AFFORDABLE FLAT-RATE PRICING - NO HIDDEN FEES!
            </div>
            
            <h1 className="text-5xl md:text-7xl font-black mb-8 text-white leading-tight">
              💰 RHEEM / AO SMITH DEAL 💰
              <span className="block text-4xl md:text-6xl text-yellow-300 mt-4">
                $2,000 Water Heater
              </span>
              <span className="block text-3xl md:text-5xl text-yellow-200 mt-2">
                FULLY INSTALLED!
              </span>
            </h1>
            
            {/* MASSIVE SAVINGS HIGHLIGHT */}
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border-4 border-yellow-400 max-w-4xl mx-auto mb-8 border border-white/20">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-black text-white mb-4">
                  💰 SAVE $1,000 - $4,000 vs. Competitors!
                </p>
                <p className="text-lg font-bold text-yellow-100 mb-4">
                  Professional Rheem & AO Smith Installation with Master Plumber Quality
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-lg font-bold">
                  <div className="bg-gradient-to-r from-action-urgent to-red-600 text-white p-4 rounded-xl">
                    <div className="text-xl">❌ Other Companies Charge:</div>
                    <div className="text-3xl font-black">$3,000 - $6,000</div>
                    <div className="text-sm">Hidden fees + markup</div>
                  </div>
                  <div className="bg-gradient-to-r from-success-primary to-success-eco text-white p-4 rounded-xl">
                    <div className="text-xl">✅ Our Flat-Rate Deal:</div>
                    <div className="text-3xl font-black">$2,000 - $2,100</div>
                    <div className="text-sm">All-inclusive pricing</div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* PRIMARY CALL TO ACTION */}
            <div className="flex flex-col lg:flex-row gap-6 justify-center items-center mb-8">
              <button 
                onClick={(e) => {
                  e.preventDefault();
                  const contactForm = document.getElementById('contact-form');
                  if (contactForm) {
                    contactForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                }}
                className="relative bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 hover:from-yellow-300 hover:via-orange-400 hover:to-red-400 text-black px-10 py-6 rounded-full text-2xl font-black inline-flex items-center transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-[1.08] ring-4 ring-yellow-300/50 animate-gradient-shift cursor-pointer"
                style={{
                  textShadow: '2px 2px 4px rgba(255,255,255,0.3)',
                  boxShadow: '0 0 30px rgba(251, 191, 36, 0.8), 0 0 60px rgba(251, 191, 36, 0.6), 0 20px 40px rgba(0,0,0,0.3)',
                }}
              >
                <ArrowRight size={28} className="mr-4" />
                <span className="relative z-10 whitespace-nowrap">
                  SUBMIT FORM!
                </span>
              </button>
              
              
              
              <a 
                href="/#contact"
                className="bg-gradient-to-r from-trust-primary to-trust-deep hover:shadow-xl hover:scale-[1.02] text-white px-8 py-4 rounded-full text-xl font-bold inline-flex items-center transition-all duration-300 shadow-xl border-2 border-white"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/#contact';
                }}
              >
                <Phone size={24} className="mr-3" />
                Contact Us
              </a>
            </div>
            
            {/* VALUE PROPOSITION */}
            <div className="bg-gradient-to-r from-black/80 to-black/60 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-yellow-400 max-w-3xl mx-auto">
              <div className="flex items-center justify-center mb-4">
                <Award size={32} className="text-yellow-400 mr-3" />
                <h3 className="text-2xl font-bold text-white">✅ TRANSPARENT FLAT-RATE PRICING</h3>
                <Award size={32} className="text-yellow-400 ml-3" />
              </div>
              <p className="text-xl text-yellow-200 font-bold leading-relaxed">
                Colorado's ONLY plumber showing exact water heater prices online. 
                <span className="text-yellow-300">What you see is what you pay</span> - no surprise charges or hidden fees!
              </p>
            </div>
          </div>
        </section>

        {/* Trust & Authority Section - 5-Card Layout */}
        <section className="py-16 bg-gradient-to-bl from-blue-900 to-blue-950 overflow-hidden">
          <div className="container-custom relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
              Why Denver Metro Trusts Our Affordable Water Heater Installation Services
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-yellow-400 mb-2">18,000+</div>
                <div className="text-lg font-semibold text-white mb-2">Jobs Completed</div>
                <p className="text-blue-100 text-sm">Since 2018 serving Littleton, Denver Metro, and surrounding areas</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-green-400 mb-2">360+</div>
                <div className="text-lg font-semibold text-white mb-2">Google Reviews</div>
                <p className="text-blue-100 text-sm">4.8★ average rating with verified customer feedback from recent water heater installations</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-blue-400 mb-2">30+</div>
                <div className="text-lg font-semibold text-white mb-2">Jurisdictions</div>
                <p className="text-blue-100 text-sm">Licensed in 30+ Colorado cities and counties</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-green-400 mb-2">A+</div>
                <div className="text-lg font-semibold text-white mb-2">BBB Rating</div>
                <p className="text-blue-100 text-sm">Accredited business with excellent track record</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                <div className="text-4xl font-bold text-orange-400 mb-2">ONLY</div>
                <div className="text-lg font-semibold text-white mb-2">Licensed Plumber</div>
                <p className="text-blue-100 text-sm">Showing Affordable Prices Online with 1000+ Verified Reviews</p>
              </div>
            </div>
          </div>
        </section>

        {/* Pre-Installation Educational Block */}
        <section className="py-16 bg-gradient-to-br from-blue-800 to-blue-900">
          <div className="container-custom text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Affordable Water Heater Installation Cost - $2,000 for 40 Gallon, $2,100 for 50 Gallon</h2>
                      </div>
        </section>

        {/* IMPORTANT NOTICE BANNER - After Hero, Before Gallery */}
        <section className="py-12 bg-gradient-to-br from-blue-800 to-blue-900 border-y-4 border-amber-400">
          <div className="container-custom">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl border-2 border-amber-400 shadow-xl p-6 max-w-5xl mx-auto border border-white/20">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-amber-400 rounded-full flex items-center justify-center">
                    <AlertTriangle size={24} className="text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                    ⚠️ IMPORTANT: Special Pricing Restriction
                  </h3>
                  <p className="text-lg md:text-xl text-white leading-relaxed mb-4">
                    <strong>This $2,000-$2,100 special is for Rheem & AO Smith Standard Atmospheric Vented Natural Gas Water Heaters ONLY.</strong>
                  </p>
                  <div className="bg-gradient-to-r from-blue-800/90 to-blue-900/90 backdrop-blur-sm rounded-lg p-4 border-l-4 border-yellow-400">
                    <p className="text-white font-semibold mb-4">
                      Looking for other water heater options? We have transparent pricing for all types:
                    </p>
                    <div className="space-y-3">
                      <a 
                        href="/water-heater-pricing" 
                        className="inline-flex items-center bg-gradient-to-r from-trust-primary to-trust-deep hover:from-trust-deep hover:to-authority-navy text-white px-6 py-3 rounded-lg font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[1.02] w-full sm:w-auto"
                      >
                        <DollarSign size={20} className="mr-2" />
                        Bradford White, Power Vent & Direct Vent Pricing
                        <ArrowRight size={20} className="ml-2" />
                      </a>
                      <p className="text-blue-100 text-sm mt-2">
                        • Bradford White 40/50 Gallon: $2,300-$2,400<br/>
                        • Power Vent Models: $4,450-$4,850<br/>
                        • Direct Vent Models: $4,350<br/>
                        • Electric Water Heaters: $5,395-$5,695
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* 40 Gallon Rheem/AO Smith Service Section */}
        <section id="40-gallon-deal" className="py-16 bg-gradient-to-bl from-green-800 to-green-900">
          <div className="container-custom mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center">How Much Does a 40-Gallon Rheem/AO Smith Installation Cost?</h2>
            <p className="text-green-200 text-lg text-center mt-4 max-w-3xl mx-auto">
              Colorado First Plumbing and Sewer LLC offers transparent $2,000 flat-rate pricing for 40-gallon Rheem/AO Smith water heaters - the only Denver Metro contractor showing exact costs online. We require photos of existing equipment sent via text/email for verification.
            </p>
          </div>
          <div className="container-custom">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                {/* Content */}
                <div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                    <div className="flex items-center mb-6">
                      <div className="w-16 h-16 bg-gradient-to-r from-success-primary to-success-eco rounded-full flex items-center justify-center mr-4 shadow-lg">
                        <Thermometer size={32} className="text-white" />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white mb-2">40-Gallon Rheem/AO Smith Deal</h3>
                        <div className="text-4xl font-bold text-yellow-300 mb-2">$2,000</div>
                        <p className="text-green-200 text-sm">Professional installation, fully installed</p>
                      </div>
                    </div>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Rheem or AO Smith 40-gallon water heater</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Professional installation by licensed master plumber</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Thermal expansion tank included</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Water heater drain pan for protection</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">2 flex water lines and gas drip leg</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Brought up to current IPC codes</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Old unit removal and proper disposal</span>
                      </div>
                    </div>
                    
                    <div className="text-center mb-6">
                      <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        
                        <button
                          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                          className="bg-gradient-to-r from-blue-500 to-blue-600 hover:shadow-xl hover:scale-[1.02] text-white px-6 py-3 rounded-full font-bold transition-all duration-300 inline-block"
                        >
                          📝 Fill Out Form
                        </button>
                        
                      </div>
                      <div className="bg-yellow-500/20 border border-yellow-400/50 rounded-lg p-4 mt-4">
                        <h5 className="text-yellow-300 font-bold text-sm mb-2">⚠️ $2,000 Deal Requirements:</h5>
                        <div className="text-green-100 text-xs space-y-1">
                          <p>• Natural gas to natural gas replacement only</p>
                          <p>• Standard 40-gallon size (not skinny or special units)</p>
                          <p>• Accessible location (not crawlspace, attic, or cellar)</p>
                          <p>• Standard existing materials - no galvanized pipe connections</p>
                          <p>• Additional charges apply for special circumstances</p>
                        </div>
                      </div>
                    </div>

                    {/* 40-Gallon Q&A */}
                    <div className="space-y-6">
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">What's included in the $2,000 40-gallon installation?</h4>
                        <p className="text-green-100">Colorado First Plumbing and Sewer LLC's $2,000 deal includes everything: Rheem or AO Smith 40-gallon atmospheric water heater, professional installation by licensed master plumber, thermal expansion tank, water heater drain pan, 2 flex water lines, gas drip leg assembly, and brought up to current IPC codes.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">Is the thermal expansion tank included in the $2,000 price?</h4>
                        <p className="text-green-100">Yes, the thermal expansion tank is included at no extra charge. Unlike other companies that add this as a surprise cost, we include all code-required components in our flat-rate pricing. The thermal expansion tank is required by most Colorado jurisdictions for safety.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">Do you charge extra to haul away the old water heater?</h4>
                        <p className="text-green-100">No disposal fees whatsoever. Colorado First Plumbing and Sewer LLC includes old water heater removal and proper recycling at no extra charge. This is part of our true flat-rate, all-inclusive pricing - what you see online is what you pay.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                                                                      </div>
                    </div>
                  </div>
                </div>

                {/* Images */}
                <div className="space-y-6">
                  <img
                    src="/colorado-plumbing-uploads/rheem-aosmith-water-heaters/AOSmith-Water-Heater-Special.JPEG"
                    alt="Professional Rheem 40-gallon water heater installation showing quality components"
                    className="w-full rounded-2xl shadow-xl border border-white/20"
                  />
                  <img
                    src="/colorado-plumbing-uploads/locations/denver/ao-smith-skinny-40-gallon-installed-denver.JPEG"
                    alt="AO Smith 40-gallon water heater professional installation in Denver with thermal expansion tank"
                    className="w-full rounded-2xl shadow-xl border border-white/20"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 50 Gallon Rheem/AO Smith Service Section */}
        <section id="50-gallon-deal" className="py-16 bg-gradient-to-bl from-blue-800 to-blue-900">
          <div className="container-custom mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center">How Much Does a 50-Gallon Rheem/AO Smith Installation Cost?</h2>
            <p className="text-blue-200 text-lg text-center mt-4 max-w-3xl mx-auto">
              Colorado First Plumbing and Sewer LLC offers transparent $2,100 flat-rate pricing for 50-gallon Rheem/AO Smith water heaters - perfect for larger households with higher hot water demand.
            </p>
          </div>
          <div className="container-custom">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                {/* Content */}
                <div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                    <div className="flex items-center mb-6">
                      <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center mr-4 shadow-lg">
                        <Home size={32} className="text-white" />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white mb-2">50-Gallon Rheem/AO Smith Deal</h3>
                        <div className="text-4xl font-bold text-yellow-300 mb-2">$2,100</div>
                        <p className="text-blue-200 text-sm">Professional installation, fully installed</p>
                      </div>
                    </div>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Rheem or AO Smith 50-gallon water heater</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Professional installation by licensed master plumber</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Thermal expansion tank included</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Water heater drain pan for protection</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">2 flex water lines and gas drip leg</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Brought up to current IPC codes</span>
                      </div>
                      <div className="flex items-center">
                        <CheckCircle size={16} className="text-yellow-300 mr-3 flex-shrink-0" />
                        <span className="text-white text-sm">Old unit removal and proper disposal</span>
                      </div>
                    </div>
                    
                    <div className="text-center mb-6">
                      <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        
                        <button
                          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                          className="bg-gradient-to-r from-green-500 to-green-600 hover:shadow-xl hover:scale-[1.02] text-white px-6 py-3 rounded-full font-bold transition-all duration-300 inline-block"
                        >
                          📝 Fill Out Form
                        </button>
                        
                      </div>
                      <div className="bg-yellow-500/20 border border-yellow-400/50 rounded-lg p-4 mt-4">
                        <h5 className="text-yellow-300 font-bold text-sm mb-2">⚠️ $2,100 Deal Requirements:</h5>
                        <div className="text-blue-100 text-xs space-y-1">
                          <p>• Natural gas to natural gas replacement only</p>
                          <p>• Standard 50-gallon size (not skinny or special units)</p>
                          <p>• Accessible location (not crawlspace, attic, or cellar)</p>
                          <p>• Standard existing materials - no galvanized pipe connections</p>
                          <p>• Additional charges apply for special circumstances</p>
                        </div>
                      </div>
                    </div>

                    {/* 50-Gallon Q&A */}
                    <div className="space-y-6">
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">What's included in the $2,100 50-gallon installation?</h4>
                        <p className="text-blue-100">Colorado First Plumbing and Sewer LLC's $2,100 deal includes everything: Rheem or AO Smith 50-gallon atmospheric water heater, professional installation by licensed master plumber, thermal expansion tank, water heater drain pan, 2 flex water lines, gas drip leg assembly, and brought up to current IPC codes.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">Is a 50-gallon unit right for my household?</h4>
                        <p className="text-blue-100">A 50-gallon water heater is perfect for 3-5 person households or homes with high hot water usage (multiple bathrooms, large soaking tubs, etc.). It provides approximately 40-50 gallons of usable hot water per cycle, ensuring everyone gets hot showers even during peak usage times.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">How much more energy does a 50-gallon use vs 40-gallon?</h4>
                        <p className="text-blue-100">The energy difference is minimal - only about $3-5 more per month. Both sizes have similar energy efficiency ratings. The 50-gallon provides significantly more hot water capacity for just slightly higher operating costs, making it excellent value for larger households.</p>
                      </div>
                      <div className="border-t border-white/20 pt-6">
                        <h4 className="text-lg font-bold text-yellow-300 mb-3">What's the recovery rate difference between 40 and 50 gallon?</h4>
                        <p className="text-blue-100">Both use similar gas burners (around 40,000 BTU), so recovery rates are comparable - about 22-23 gallons per hour. The 50-gallon's advantage is the larger storage capacity, not faster heating, which means less waiting between high-usage periods.</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Images */}
                <div className="space-y-6">
                  <img
                    src="/colorado-plumbing-uploads/rheem-aosmith-water-heaters/rheem-50-gallon-replacement-thermal-tank-centennial.JPEG"
                    alt="Professional Rheem 50-gallon water heater installation in Centennial with thermal expansion tank"
                    className="w-full rounded-2xl shadow-xl border border-white/20"
                  />
                  <img
                    src="/colorado-plumbing-uploads/rheem-aosmith-water-heaters/50-gallon-replacement-thornton.JPEG"
                    alt="50-gallon water heater professional installation in Thornton showing quality workmanship"
                    className="w-full rounded-2xl shadow-xl border border-white/20"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Master Plumber Attribution */}
        <section className="py-16 bg-gradient-to-br from-purple-800 to-purple-900">
          <div className="container-custom max-w-4xl">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <img
                  src="/colorado-plumbing-uploads/brand/codee-christian-plumbing-truck.png"
                  alt="Codee Jessen - Master Plumber with Colorado First Plumbing service truck"
                  className="w-32 h-32 rounded-full object-cover bg-white/5 border-4 border-white/20 shadow-lg"
                />
                <div className="flex-grow text-center md:text-left">
                  <h3 className="text-2xl font-bold text-white mb-1">Master Plumber - Water Heater Specialist</h3>
                  <h4 className="text-xl font-semibold text-yellow-300 mb-2">Codee Jessen</h4>
                  <p className="text-sm text-purple-200 mb-4 italic">
                    "Why do we show exact prices online when other companies won't? Because we're confident in our quality, our process, and our value. Every $2,000/$2,100 installation meets manufacturer specifications and includes everything needed for safe, code-compliant operation. No hidden fees, no surprise charges - just honest, transparent pricing."
                  </p>
                  <div className="text-purple-100 mb-4">
                    <p>• Specialties: Water Heater Installation, Code Compliance, Transparent Pricing</p>
                    <p>• Experience: 18,000+ jobs completed, Licensed Master Plumber</p>
                    <p>• Commitment: Flat-rate pricing with photo verification for qualified installs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Competitive Differentiation Section */}
        <section className="py-16 bg-gradient-to-br from-orange-800 to-orange-900">
          <div className="container-custom">
            <div className="text-center max-w-4xl mx-auto mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Why We're The ONLY Plumber Showing Exact Prices Online
              </h2>
              <p className="text-xl text-orange-200 leading-relaxed">
                Challenge other contractors: If they're truly "affordable," why won't they show their prices?
              </p>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
              {/* Transparency Card */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-success-primary to-success-eco rounded-full flex items-center justify-center mx-auto mb-4">
                    <DollarSign size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">Our Transparent Approach</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <CheckCircle size={20} className="text-success-eco flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">Exact Prices Online</h4>
                      <p className="text-orange-200 text-sm">$2,000 for 40-gallon, $2,100 for 50-gallon - no guessing, no "call for pricing"</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <CheckCircle size={20} className="text-success-eco flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">No Consultation Required</h4>
                      <p className="text-orange-200 text-sm">For qualified installations - clear requirements listed, no sales visits needed</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <CheckCircle size={20} className="text-success-eco flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">Complete Inclusions</h4>
                      <p className="text-orange-200 text-sm">Everything listed - thermal expansion tank, drain pan, removal, disposal</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <CheckCircle size={20} className="text-success-eco flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">Clear Exclusions</h4>
                      <p className="text-orange-200 text-sm">When additional charges apply - no surprises at completion</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Challenge Competitors Card */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-action-primary to-action-urgent rounded-full flex items-center justify-center mx-auto mb-4">
                    <AlertTriangle size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">Ask Other Companies</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <XCircle size={20} className="text-red-400 flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">Why No Prices Online?</h4>
                      <p className="text-orange-200 text-sm">If they're "affordable," why hide pricing until after sales visit?</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <XCircle size={20} className="text-red-400 flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">What's Actually Included?</h4>
                      <p className="text-orange-200 text-sm">Expansion tank extra? Disposal fee? Permit costs? You won't know until the end.</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <XCircle size={20} className="text-red-400 flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">How Much Will It Really Cost?</h4>
                      <p className="text-orange-200 text-sm">Base price + extras + fees + markups = ? (You'll find out at signing)</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <XCircle size={20} className="text-red-400 flex-shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-white">Why Send Salesmen?</h4>
                      <p className="text-orange-200 text-sm">If pricing is straightforward, why not send the actual plumber?</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="text-center mt-12">
              <div className="bg-gradient-to-r from-white/20 to-white/10 rounded-2xl p-8 shadow-2xl text-white max-w-3xl mx-auto border border-white/20">
                <h3 className="text-2xl font-bold mb-4">The Colorado First Plumbing Difference</h3>
                <p className="text-xl mb-6 text-orange-100">
                  We show prices because we're confident in our value. Others hide prices because they're not.
                </p>
                
              </div>
            </div>
          </div>
        </section>

        {/* REQUIREMENTS & EXCLUSIONS - TRANSPARENCY - Flipped gradient */}
        <section className="py-16 bg-gradient-to-bl from-action-primary via-authority-navy to-trust-primary text-white relative overflow-hidden">
          <div className="container-custom">
            <div className="text-center max-w-4xl mx-auto mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
                📋 Requirements & Exclusions
              </h2>
              <p className="text-xl text-trust-light/90 leading-relaxed">
                We believe in complete transparency. Here are the requirements and exclusions for our summer special:
              </p>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Requirements */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-success-primary to-success-eco rounded-full flex items-center justify-center mx-auto mb-4">
                    <CheckCircle size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white">✅ Requirements</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">🏠 Good Access Required</h4>
                    <p className="text-trust-light/90 text-sm">No crawlspace, cellar, or attic installations. Must have clear, accessible location.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">⛽ Natural Gas to Natural Gas</h4>
                    <p className="text-trust-light/90 text-sm">Like-for-like replacement only. Existing natural gas to new natural gas unit. Atmospheric Vented Standard Unit Only.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">🔧 Standard Existing Materials</h4>
                    <p className="text-trust-light/90 text-sm">Connecting to standard existing materials. Additional fees for galvanized water pipe connections.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">📏 Standard Size Units</h4>
                    <p className="text-trust-light/90 text-sm">40 or 50 gallon standard size (not skinny or special size units).</p>
                  </div>
                </div>
              </div>
              
              {/* Additional Costs */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-action-primary to-action-urgent rounded-full flex items-center justify-center mx-auto mb-4">
                    <DollarSign size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-action-primary">💰 Additional Costs</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">🔧 Galvanized Pipe Connections</h4>
                    <p className="text-trust-light/90 text-sm">Additional charge for connecting to galvanized water pipes.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">🏠 Difficult Access Locations</h4>
                    <p className="text-trust-light/90 text-sm">Crawlspace, cellar, or attic installations require additional pricing.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">📏 Special Size Units</h4>
                    <p className="text-trust-light/90 text-sm">Skinny, tall, or special size water heaters not included in special pricing.</p>
                  </div>
                  
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/30">
                    <h4 className="font-bold text-white mb-2">🔄 Fuel Type Conversions</h4>
                    <p className="text-trust-light/90 text-sm">Converting from electric to gas or vice versa requires separate pricing.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Call to Action */}
            <div className="text-center mt-12">
              <div className="bg-gradient-to-r from-trust-primary to-success-primary rounded-2xl p-8 shadow-2xl text-white max-w-3xl mx-auto">
                <h3 className="text-2xl font-bold mb-4">Questions About Your Specific Situation?</h3>
                <p className="text-xl mb-6 text-trust-light">
                  Call us to discuss your water heater installation needs. We'll let you know if your situation qualifies for our summer special pricing!
                </p>
                
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section id="contact-form" className="py-20 bg-gradient-to-br from-gray-900 to-gray-800">
          <div className="container-custom">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Ready to Get Your $2,000/$2,100 Water Heater Installed?
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                We do require photos of your existing water heater sent via text or email to verify compatibility. Fill out the form below or call  to schedule your flat-rate water heater installation.
              </p>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
              {/* Contact Form */}
              <div>
                <ContactForm />
              </div>
              
              {/* Contact Info */}
              <div>
                <ContactInfo />
              </div>
            </div>
          </div>
        </section>

        {/* FINAL VALUE PROPOSITION CTA */}
        <section className="py-20 bg-gradient-to-bl from-blue-800 via-blue-700 to-blue-600 text-white relative overflow-hidden">
          <div className="container-custom text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center px-6 py-3 mb-8 rounded-full bg-yellow-400 text-black font-black text-lg shadow-2xl">
                <Award size={24} className="mr-3" />
                🏆 COLORADO'S ONLY PLUMBER WITH ONLINE PRICING!
              </div>
              
              <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight">
                Experience the 
                <span className="block text-yellow-300">TRANSPARENT DIFFERENCE!</span>
              </h2>
              
              <p className="text-2xl mb-8 leading-relaxed">
                $2,000 for a complete Rheem/AO Smith water heater installation that other companies charge 
                <span className="text-yellow-300 font-bold"> $3,000-$6,000</span> for!
              </p>
              
              <div className="flex flex-col lg:flex-row gap-6 justify-center items-center">
                
                
                
                
                <a 
                  href="/#contact"
                  className="bg-gradient-to-r from-trust-primary to-trust-deep hover:bg-white/30 text-white px-8 py-4 rounded-full text-xl font-bold inline-flex items-center transition-all duration-300 shadow-xl border-2 border-white"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/#contact';
                  }}
                >
                  <Phone size={24} className="mr-3" />
                  Contact Us
                </a>
              </div>
              
              <div className="mt-8 p-6 bg-black/30 backdrop-blur-sm rounded-2xl border border-yellow-400/50">
                <p className="text-xl font-bold text-yellow-200">
                  💰 Flat-rate pricing with no hidden fees - what you see is what you pay!
                </p>
              </div>
            </div>
          </div>
        </section>

      </main>
      <Footer />
      
      {/* Schema Injection */}
      <SchemaInjector 
        schemas={[completePageSchema]}
        title="$2000 Water Heater Deal Denver: Rheem & AO Smith | Colorado First Plumbing"
        description="Get a 40-gallon Rheem or AO Smith water heater fully installed for a flat-rate of $2,000 in the Denver Metro area. 50-gallon for $2,100. 360 Google Reviews. No hidden fees."
        canonical="https://colorado-plumbing.com/flat-rate-affordable-rheem-water-heaters-in-colorado"
        keywords="denver water heater deal, $2000 water heater denver, rheem water heater price, ao smith installation cost, flat-rate plumber littleton"
      />
    </div>
  );
};

export default FlatRateRheemHeaterPricing;